import React from 'react';
import {
    Dialog, DialogTitle, DialogContent, DialogActions,
    Button, Alert, CircularProgress, Typography, IconButton, Box,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { resolverPlantillaAmparo } from '../../utils/resolverPlantillaAmparo';

/**
 * Confirma qué plantilla del escrito de Amparo de PNC se va a emitir (ANDIS con CMO / ANDIS sin
 * CMO, ver resolverPlantillaAmparo) y muestra los avisos correspondientes antes de descargar. Sin
 * selector manual de plantilla: la elige si se cuenta con copia del CMO del trámite, no el usuario.
 *
 * Desde V239 ya no ofrece la variante ANSES: ese escrito se emite desde el módulo Amparo por mora
 * (BotonGenerarEscritoAmparo), que sabe por qué trámite previsional es el amparo. Con organismo =
 * ANSES el modal muestra el aviso de resolverPlantillaAmparo y deja el botón deshabilitado.
 */
export default function ModalGenerarAmparoPnc({ abierto, generando, datos, onCancelar, onConfirmar }) {
    const { titulo, avisos, clave } = resolverPlantillaAmparo(datos || {});

    return (
        <Dialog open={abierto} onClose={generando ? undefined : onCancelar} maxWidth="sm" fullWidth>
            <DialogTitle sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                Generar escrito de Amparo por mora
                <IconButton type="button" onClick={onCancelar} disabled={generando} size="small">
                    <CloseIcon fontSize="small" />
                </IconButton>
            </DialogTitle>
            <DialogContent dividers>
                {clave ? (
                    <Typography variant="body1" sx={{ mb: 2 }}>
                        Se va a generar: <strong>{titulo}</strong>
                    </Typography>
                ) : null}

                {avisos.map((aviso, i) => (
                    <Alert key={i} severity={clave ? 'warning' : 'error'} sx={{ mb: 1 }}>
                        {aviso}
                    </Alert>
                ))}

                {clave && (
                    <Box sx={{ mt: 1 }}>
                        <Typography variant="body2" color="text.secondary">
                            Revisá el documento generado antes de presentarlo: nombre, DNI, domicilio,
                            N° de expediente y fecha de inicio salen del cliente y del trámite.
                        </Typography>
                    </Box>
                )}
            </DialogContent>
            <DialogActions>
                <Button type="button" onClick={onCancelar} disabled={generando}>Cancelar</Button>
                <Button
                    type="button"
                    variant="contained"
                    onClick={onConfirmar}
                    disabled={generando || !clave}
                    startIcon={generando ? <CircularProgress size={16} color="inherit" /> : null}
                >
                    {generando ? 'Generando...' : 'Generar y descargar'}
                </Button>
            </DialogActions>
        </Dialog>
    );
}
